
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Neighborhood {
  id: string;
  city: string;
  state: string;
  country: string;
  description?: string;
  long_description?: string;
  created_at: string;
  updated_at: string;
}

export const useNeighborhoods = (searchTerm?: string) => {
  return useQuery({
    queryKey: ['neighborhoods', searchTerm],
    queryFn: async (): Promise<Neighborhood[]> => {
      console.log('🏘️ Fetching neighborhoods from Supabase...');
      
      let query = supabase
        .from('neighborhoods')
        .select('*')
        .order('city', { ascending: true });

      if (searchTerm && searchTerm.trim() !== '') {
        query = query.or(`city.ilike.%${searchTerm}%,state.ilike.%${searchTerm}%`);
      }

      const { data: neighborhoods, error } = await query;

      if (error) {
        console.error('Error fetching neighborhoods:', error);
        throw error;
      }

      console.log(`✅ Fetched ${neighborhoods?.length || 0} neighborhoods from Supabase`);
      return neighborhoods || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
